import { AppEntities } from "../../../../config/entities";
import React from "react";
import { NewCatalogListView } from "../../../Shared/NewCatalogListView";
import { IListViewField } from "../../../Shared/ILIstViewField";
import { CatalogListView } from "../../../Shared/CatalogListView";
import { CatalogListViewToolbar } from "../../../Shared/ListViews/CatalogListViewToolbar";
import { CatalogListViewDefaultToolbarButtons } from "../../../Shared/ListViews/CatalogListViewDefaultToolbarButtons";

const WarehouseList = () => {
  const fields: IListViewField[] = [{ title: "Address", fieldName: "actualAddress" }];

  return (
    <>
      <CatalogListView fields={fields} entity={AppEntities.Warehouse}>
        <CatalogListViewToolbar>
          <CatalogListViewDefaultToolbarButtons />
        </CatalogListViewToolbar>
      </CatalogListView>{" "}
    </>
  );
};

export default WarehouseList;
